import emptyImg from '@/pages/RepairInfoSearch/assets/empty.svg';
import styles from './index.module.less';

export default function Empty(props) {
  const { description } = props;
  return (
    <div className={styles['empty-center']}>
      <img className={styles['empty-image']} src={emptyImg} alt='empty' />
      <p className={styles['empty-text']}>{description || 'No Data'}</p>
    </div>
  );
}
